module.exports = __webpack_public_path__ + "img/nineInterger.9ef509ca.png";